module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.3cd143a8.jpg";